// Prospect cooldowns. Ruling: "not interested" lasts 180 CALENDAR days and ends at 12:00 America/Toronto.
// Shared by the dialer outcome effects and (later) the import status map; SQL log_call_outcome uses the same rule.
import { addDays } from "./time/toronto";
import { BUSINESS_TZ, localDateOf, zonedTimeToUtc } from "./torontoTime";

export const NOT_INTERESTED_COOLDOWN_DAYS = 180;
export const COOLDOWN_END_TIME = "12:00";

/** Toronto calendar day of `now` + 180 days, at 12:00 Toronto, as an ISO UTC string. */
export function notInterestedCooldownUntil(now: Date): string {
  const day = addDays(
    localDateOf(now, BUSINESS_TZ),
    NOT_INTERESTED_COOLDOWN_DAYS,
  );
  return zonedTimeToUtc(day, COOLDOWN_END_TIME, BUSINESS_TZ).toISOString();
}
